<script>
export default {
   name: 'SingleUSSupplies',
};
</script>

<template>
   <svg xmlns="http://www.w3.org/2000/svg" width="128" height="86" fill="none" viewBox="0 0 128 86">
      <g>
         <path
            fill="#bbc7d5"
            d="m74.356 11.243 1.184 1.184h1.93l-2.746 2.747h4.807l1.792-1.792h1.362v1.447l1.715 1.716 1.742-1.742h3.787l2.167 2.165h-4.912l-4.495 4.497 1.211 1.211v6.5l2.09 2.09 1.78-1.778v-4.311l-1.79-1.79 4.84-4.84 3.599 3.598-2.257 2.26h3.435v2.753l-2.608 2.606 2.343 2.343 5.8-5.8h3.073l3.683-3.681h2.253v-4.142l1.829-1.83h4.568l4.043-4.042V6.757h2.586l2.086 2.084v2.845l1.948 1.95-1.601 1.601h-1.722v3.344l-3.061 3.06 2.479 2.479-2.685 2.685h-2.838l-2.819 2.816v5.44h-2.106l2.523 2.523-1.883 1.885-3.075-3.076v3.258l4.317 4.315v4.87l-5.521 5.521h-2.451l-4.161 4.164v5.339l5.87 5.87v9.363h-2.915l-3.604-3.602v-4.736l-4.79-4.79H80.642l3.036 3.037-2.08 2.08-3.562-3.563h-7.183l-8.702 8.702v3.466h-4.644l-3.211-3.211V72.77l-5.614-5.614-2.615 2.613-4.367-4.368V60.89H26.648l-7.193-7.196H12.01l-7.332-7.333v-9.786L.05 31.947v-7.632l3.233-3.234v-7.45L8.22 8.697V2.913h2.665l1.68 1.679V.799l31.361 6.719z"
         />
         <path fill="#e2bd4d" d="M41.593 34.755h13.896v17.001H41.593z" />
         <path
            stroke="#178ece"
            stroke-width="2"
            d="M41.589 36.199c0-.66.534-1.194 1.194-1.194h12.116c.66 0 1.194.535 1.194 1.194v14.2c0 .659-.535 1.193-1.194 1.193H42.782c-.659 0-1.193-.534-1.193-1.193z"
         />
      </g>
   </svg>
</template>

<style scoped lang="scss"></style>
